import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useUnit } from 'hooks/units/index';
import useI18n from 'hooks/use-i18n';
import useWindowSize from 'hooks/useWindowSize';
import Complete from './Complete/Complete';
import { Button } from 'reactstrap';
import { ArrowLeft, ArrowRight } from 'react-feather';
import classNames from 'classnames';
import styles from 'styles/Unit.module.scss';
import ThemeButton from 'components/AntdFormInputs/theme-button';

const ContentLTI = () => {
  const i18n = useI18n();
  const unitSelected = useUnit();
  const [currentIndex, setCurrentIndex] = useState(0);
  const iframeRef = useRef(null);
  const [windowWidth] = useWindowSize();

  const packages = useMemo(() => {
    const raw = unitSelected?.ltiPackages;
    if (!Array.isArray(raw)) return [];
    return raw.filter(
      (p) => p && typeof p.url === 'string' && p.url.trim().length > 0,
    );
  }, [unitSelected?.ltiPackages]);

  useEffect(() => {
    setCurrentIndex((i) => {
      if (packages.length === 0) return 0;
      return Math.min(i, packages.length - 1);
    });
  }, [packages.length]);

  const current = packages[currentIndex];
  const total = packages.length;
  const canPrev = currentIndex > 0;
  const canNext = currentIndex < total - 1;

  if (total === 0) {
    return (
      <div className="p-3">
        <p className="text-muted mb-0">{i18n.t('course.ltiNoPackages')}</p>
        <Complete />
      </div>
    );
  }

  return (
    <div
      className={classNames('containerContent', styles.containerContent)}
      id="content"
    >
      <div
        className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-2 px-1"
        style={{ rowGap: 8 }}
      >
        <div className="flex-grow-1 min-w-0">
          <h4 className="mb-0 text-truncate" title={current?.title}>
            {current?.title || `LTI ${currentIndex + 1}`}
          </h4>
          <small className="text-muted">
            {i18n.t('course.ltiResourceOf', {
              current: currentIndex + 1,
              total,
            })}
          </small>
        </div>
        <div className="d-flex align-items-center flex-shrink-0">
          <ThemeButton
            variant="secondary"
            className="mr-1 d-flex align-items-center"
            disabled={!canPrev}
            padding="5px 10px"
            onClick={() => setCurrentIndex((i) => Math.max(0, i - 1))}
          >
            <ArrowLeft size={18} />
            {i18n.t('table.previous')}
          </ThemeButton>
          <ThemeButton
            variant="secondary"
            className="d-flex align-items-center"
            padding="5px 10px"
            disabled={!canNext}
            onClick={() => setCurrentIndex((i) => Math.min(total - 1, i + 1))}
          >
            {i18n.t('table.next')}
            <ArrowRight size={18} />
          </ThemeButton>
        </div>
      </div>
      <div className="overflow-auto modal-body  fill-overflow-image">
        <iframe
          ref={iframeRef}
          key={`lti-pkg-${currentIndex}-${current?.packageId ?? current?.url}`}
          title={current?.title || 'LTI'}
          src={current.url}
          allow="fullscreen; autoplay; camera; microphone; display-capture"
        />
      </div>
      <Complete />
    </div>
  );
};

export default ContentLTI;
